import React from "react";

const PageOverlay = () => {
  return <div className="page-overlay"></div>;
};

export default PageOverlay;
